module.exports = __webpack_public_path__ + "finger_lakes.557332849423831d2fbc057851135355.png";